import { z } from "zod";

export const placeTypeEnum = z.enum(["Rokata", "Chubun", "Sokudo", "Unknown"]);

export const placeTypeMap = {
  Rokata: "路肩",
  Chubun: "中分",
  Sokudo: "側道",
  Unknown: "不明",
};

export type PlaceType = z.infer<typeof placeTypeEnum>;
